<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Relevando"
      title="Relevando Peligros"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-tv-2 text-primary',
            path: '/dashboard',
          }"
        />

        <sidebar-item
          :link="{
            name: 'Peligros',
            icon: 'fa fa-exclamation-triangle text-orange',
            path: '/peligros',
          }"
        />

        <sidebar-item
          v-if="['administrador'].includes(role)"
          :link="{
            name: 'Responsables',
            icon: 'ni ni-building text-medium',
            path: '/responsables',
          }"
        />

        <sidebar-item
          v-if="['administrador'].includes(role)"
          :link="{
            name: 'Sedes',
            icon: 'ni ni-shop text-info',
            path: '/sedes',
          }"
        />
        <sidebar-item
          :link="{
            name: 'Mapa',
            icon: 'ni ni-pin-3 text-orange',
            path: '/maps',
          }"
        />

        <sidebar-item
          v-if="['administrador'].includes(role)"
          :link="{
            name: 'Noticias',
            icon: 'fa fa-newspaper',
            path: '/posts',
          }"
        />

        <sidebar-item
          v-if="['administrador'].includes(role)"
          :link="{
            name: 'Estadísticas',
            icon: 'ni ni-chart-pie-35 text-success',
            path: '/estadisticas',
          }"
        />

        <sidebar-item
          v-if="['administrador'].includes(role)"
          :link="{
            name: 'Categorías',
            icon: 'ni ni-bullet-list-67 text-medium',
            path: '/categorias',
          }"
        />

        <sidebar-item
          :link="{
            name: 'Contacto',
            icon: 'fa fa-envelope',
            path: '/contacts',
          }"
        />

        <sidebar-item v-if="['administrador'].includes(role)"
          >Administración</sidebar-item
        >
        <sidebar-item
          :link="{
            name: 'Staff',
            icon: 'ni ni-circle-08 text-medium',
            path: '/staff',
          }"
          v-if="['administrador'].includes(role)"
        />

        <sidebar-item
          :link="{
            name: 'Usuarios',
            icon: 'ni ni-circle-08 text-medium',
            path: '/usuarios',
          }"
          v-if="['administrador'].includes(role)"
        />
        <sidebar-item
          :link="{
            name: 'Relevamientos',
            icon: 'ni ni-single-02 text-info',
            path: '/formalities',
          }"
        />

        <sidebar-item
          :link="{
            name: 'Perfil',
            icon: 'ni ni-single-02 text-orange',
            path: '/perfil',
          }"
        />

        <sidebar-item
          :link="{
            name: 'Notificaciones',
            icon: 'ni ni-bell-55 text-orange',
            path: '/notificaciones',
          }"
        />

        <hr
          class="my-3"
          style="
            border: 0;
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            min-width: 80%;
            overflow: visible;
            box-sizing: content-box;
            height: 0;
          "
        />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  async created() {
    this.$store.watch(
      () => this.$store.getters["profile/me"],
      (me) => {
        this.role = me.role;
      }
    );
    await this.$store.dispatch("profile/me");
  },

  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      role: "",
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
<style lang="scss">
.navbar-brand-img {
  width: 10rem;
  height: auto !important;
  max-height: unset !important;
  margin-top: -1rem;
  margin-bottom: -1rem;
}
</style>
